import axios from '@/axios'
import store from '@/store/store'

export default {
  getTypeTransaction (options) {
    return axios.get('/jenis-transaksi', options)
  },
  makeTransaction (payload, options) {
    const profile = store.state.auth.profile

    if(!profile) {
      return axios.post('/input/pembayaran/non-login', payload, options)
    }
    return axios.post('/input/pembayaran', payload, options)
  },
  getHistory(options) {
  	return axios.get('/pembayaran', options)
  }
}